enum TransitChargeState {
  HasCharge,
  NoCharge,
  Unknown
}

export default TransitChargeState;
